<template>
    <vs-popup class="holamundo edit-group edit-popup" title="Create GiftCard" :active.sync="createGiftcardPopup.isOpen">
        <div>
            <vs-input label="Quantity" :maxlength="30" name="quantity" v-model="quantity" class="w-full" :danger="has_err"
            :danger-text="err_message" v-on:keypress="isNumber($event)" @input="resetErr" />
            <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                <vs-button class="mr-6 align-center save-responsive" @click="createGiftcard">Create</vs-button>
                <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="closePopup">Cancel</vs-button>
            </div>
        </div>
    </vs-popup>
</template>

<script>
export default {
    name: "create-giftcard-popup",
    props: {
        createGiftcardPopup: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            quantity: 0,
            has_err: false,
            err_message: "",
            isOpenLoading: false
        }
    },
    watch: {
        createGiftcardPopup: {
            immediate: true,
            deep: true,
            handler() {
                if(!this.createGiftcardPopup.isOpen) {
                    this.quantity = 0;
                }
            }
        }
    },
    methods: {
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if(this.loadTime){
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                    this.closeLoading();
                    this.$vs.dialog({
                        color: 'danger',
                        title: 'Notification',
                        text: 'Create giftcard failed',
                        acceptText: 'OK'
                    })
                }
            }, 10000);
        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        closePopup() {
            this.createGiftcardPopup.isOpen = false;
        },
        isNumber: function(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 &&  (charCode < 48 || charCode > 57)) {
                evt.preventDefault();
            } else {
                if (this.quantity === 0 || this.quantity === '0') {
                    this.quantity = "";
                }
                return true;
            }
        },
        validateInput() {
            this.has_err = false;
            this.err_message = "";
            if (this.quantity == "" || !this.quantity) {
                this.has_err = true;
                this.err_message = "Quantity must be greater than 0";
            }
        },
        resetErr() {
            this.has_err = false;
            this.err_message = "";
        },
        createGiftcard() {
            this.validateInput();
            if(!this.has_err) {
                let obj = {
                    quantity: this.quantity
                }
                this.openLoadingInDiv();
                this.$store.dispatch("serviceList/MULTI_CREATE_GIFTCARD", obj).then(() => {
                    this.closeLoading();
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        text: "Create giftcard success",
                    });
                    this.$emit("GetData");
                    this.closePopup();
                }).catch((err) => {
                    console.log("Error: ", err);
                    this.closeLoading();
                    this.$vs.notify({
                        color: "danger",
                        title: "Failed",
                        text: "Create giftcard failed",
                    });
                });
            }
        }
    }
}
</script>